import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'

const RegisterWidgetCTA = ({ data, theme, dataTestId }) => {
  const router = useRouter()
  if (!data.ctaText) {
    return false
  }

  const { features } = useSelector((state) => state.features)
  const isPfeAuthenticated = features['enable_pfe_authentication'] &&
  features['enable_pfe_authentication'].enabled

  return (
    <Box
      alignItems='center'
      as='a'
      bg={theme.ctaBackgroundColor || 'brand'}
      boxShadow='site'
      color={theme.ctaTextColor || '#fff'}
      d='inline-flex'
      fontFamily='body'
      fontSize='body'
      fontWeight='bold'
      href={(isPfeAuthenticated && router.asPath !== '/') ? `/register?next=${router.asPath}` : '/register'}
      px={8}
      py={4}
      rounded='site'
      textTransform='uppercase'
      textDecoration='none'
      wordBreak='break-word'
      _hover={{
        bg: theme.ctaBackgroundHoverColor || theme.ctaBackgroundColor || 'brand',
        color: theme.ctaTextHoverColor || theme.ctaTextColor || '#fff'
      }}
      className='register-banner-button'
      aria-label={data.ctaText}
      data-testid={dataTestId}
    >
      {data.ctaText}
    </Box>
  )
}

RegisterWidgetCTA.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
}

export default RegisterWidgetCTA
